import { BaseConstants } from './baseConstants';
// 歯科介入
export class DentalIntervention extends BaseConstants {
  static readonly none = new DentalIntervention(
    'none',
    '歯科介入 なし',
    'Dental care: none',
  );
  static readonly inProgress = new DentalIntervention(
    'inProgress',
    '歯科介入 あり',
    'Dental care: yes',
  );
  static readonly underConsideration = new DentalIntervention(
    'underConsideration',
    '歯科介入 検討中',
    'Dental care: considering',
  );

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  toString() {
    return this.key;
  }

  static getLabelByKey(key: string): string {
    const item = this.getByKey(key);
    return item?.label || key;
  }

  static getShortLabelByKey(key: string): string {
    const labels: { [key: string]: string } = {
      none: 'なし',
      underConsideration: '検討中',
      inProgress: '実施中',
    };
    return labels[key] || key;
  }
}
